import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useResetPasswordMutation } from 'services/auth/auth.endpoint';

export const useResetPasswordVM = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userResetPasswordToken, setUserResetPasswordToken] = useState('');
    const [resetPasswordErrorMessage, setResetPasswordErrorMessage] = useState('');
    const [resetPasswordMode, setResetPasswordMode] = useState<'form' | 'success'>('form');

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        if (token) {
            setUserResetPasswordToken(token);
        }
    }, [location.search]);

    const [
        resetPassword,
        {
            isLoading: resetPasswordLoading,
            isError: resetPasswordError,
            isSuccess: resetPasswordSuccess,
            error: resetPasswordResponseError,
            data: resetPasswordResponse
        }
    ] = useResetPasswordMutation();

    const handleResetPassword = async (password: string, confirm_password: string) => {
        await resetPassword({
            token: userResetPasswordToken,
            password,
            confirm_password
        });
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    useEffect(() => {
        if (resetPasswordLoading) return;
        if (resetPasswordError && resetPasswordResponseError) {
            console.log("resetPasswordResponseError", resetPasswordResponseError);
            if ('data' in resetPasswordResponseError) {
                const errorData = resetPasswordResponseError.data as { code: string };
                if (errorData.code === 'passwords_do_not_match') {
                    setResetPasswordErrorMessage('Les mots de passe ne correspondent pas.');
                } else if (errorData.code === 'password_strong') {
                    setResetPasswordErrorMessage('Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un chiffre.');
                } else {
                    setResetPasswordErrorMessage('Une erreur est survenue');
                }
            } else {
                setResetPasswordErrorMessage('Une erreur est survenue');
            }
            return;
        }
        if (resetPasswordSuccess && resetPasswordResponse) {
            setUserResetPasswordToken('');
            setResetPasswordErrorMessage('');
            setResetPasswordMode('success');
            return;
        }
    }, [resetPasswordLoading, resetPasswordError, resetPasswordSuccess, resetPasswordResponseError, resetPasswordResponse]);

    return {
        handleResetPassword,
        resetPasswordErrorMessage,
        handleBackToLogin,
        resetPasswordMode
    };
};
